import React, { ReactNode } from 'react';
import { Controller } from 'react-hook-form';
import { Control } from 'react-hook-form/dist/types/form';
import { FieldValues } from 'react-hook-form/dist/types/fields';
import { FormControlProps, RadioGroupProps, RadioProps } from '@mui/material';
import { UseControllerProps } from 'react-hook-form/dist/types/controller';
import { FormRadioGroup } from '../FormRadioGroup';

interface RadioGroupOptions {
  value: string;
  label: ReactNode;
}

interface Props<FormValues extends FieldValues = FieldValues> extends RadioGroupProps {
  label?: string;
  disabled?: boolean;
  radioProps?: RadioProps;
  control: Control<FormValues>;
  options: RadioGroupOptions[];
  formControlProps?: FormControlProps;
  name: UseControllerProps<FormValues>['name'];
  extraAction?: (nextValue: string, name: UseControllerProps<FormValues>['name']) => void;
}

export const RadioGroupField = <FormValues extends FieldValues = FieldValues>({
  name,
  label,
  control,
  options,
  radioProps,
  extraAction,
  disabled = false,
  formControlProps,
  ...radioGroupProps
}: Props<FormValues>) => {
  return (
    <Controller
      name={name}
      control={control}
      disabled={disabled}
      render={({ field: { onChange, ...field } }) => (
        <FormRadioGroup
          label={label}
          options={options}
          radioProps={radioProps}
          formControlProps={formControlProps}
          onChange={(event, value) => {
            onChange(event, value);
            extraAction?.(value, name);
          }}
          {...field}
          {...radioGroupProps}
        />
      )}
    />
  );
};
